import { Alert, Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import { Authorized } from 'modules/core/components/Authorized'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import {
  WizardData,
  canRenameFile,
} from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal/types'
import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'
import filesStore from 'modules/documents/components/Documents/store'
import FileList from 'modules/documents/components/FileList'
import { splitFileName } from 'modules/documents/lib/files/filenameUtils'

interface Props {
  onDeleteFile: (index: number) => void
  onDropFiles: (files: File[]) => void
  isReadOnly: boolean
}

const FileUploader = ({
  data,
  onDataChanged,
  onDeleteFile,
  onDropFiles,
  isReadOnly,
}: WizardStepRenderParams<WizardData> & Props) => {
  const {
    company: { subscription },
  } = useCurrentSession()
  const { uploadType } = data

  const onDrop = (files: File[]) => {
    onDropFiles(files)

    const splittedFilename =
      canRenameFile(uploadType, filesStore.files.length) && filesStore.files[0]?.name
        ? splitFileName(filesStore.files[0]?.name)
        : undefined

    onDataChanged({
      ...data,
      combineFileName: splittedFilename?.fileName,
    })
  }

  return (
    <Box flexDirection="row">
      <Box gap="s16" padding="s24" flexNoShrink width="s400">
        <Text size="200" weight="medium" color="grey1000">
          {i18n.t('split_documents.form.documents')}
        </Text>
        <Authorized subscription={subscription}>
          <DropzoneBox
            onDrop={onDrop}
            accept={{ 'application/pdf': [] }}
            iconName={'common-file-text-upload'}
            message={i18n.t('split_documents.sidepanel.dropzone')}
            disabled={isReadOnly}
            noClick={isReadOnly}
            noDrag={isReadOnly}
          />
        </Authorized>
        <FileList files={filesStore.files} onDeleteFile={onDeleteFile} spaced={false} />
      </Box>
      <Box paddingX="s24" paddingY="s80">
        <Alert color="info">{i18n.t('split_documents.sidepanel.uploader_description')}</Alert>
      </Box>
    </Box>
  )
}

export default FileUploader
